<template>
  <div class="render">
    <div v-if="!$store.getters['user/getUserFields'].is_admin">
      Вы не администратор, авторизируйтесь как администратор!
    </div>

    <div v-else class="content_table">
      <div class="top">
        <h1>Звонки с кодом подтверждения</h1>
      </div>

      <FilterMy
       :visible="{
         date: true,
         phone: true,
         calls: users,
         callsMultiple: false,
         scripts: false,
         text: false,
         nickname: false,
         visible: false,
         target: false,
         managerVisible: false,
         maska: '+7 (###) ###-##-##'
       }"
       calls-title="Пользователь"
       calls-placeholder="Выберите"
       emptyRangeText="Выберите дату"
       @updateFilter="onFilterChange"
       @exportExcel="onExport"
     />

      <Table
        :page_type="'verification_calls'"
        :items="[]"
        :loading="loading"
        :perPage="perPage"
        :server="false"
        :hideselect="true"
        :headers="table.headers"
        :data="table.data"
        :sortedBy="{ value: 'created_at', order: 'desc' }"
      />
    </div>
  </div>
</template>

<script>
import FilterMy from '../../components/FilterMy.vue'
import Table from '../../components/Table/DataTable.vue'

export default {
  components: { Table, FilterMy },

  data () {
    return {
      loading: true,
      perPage: 10,
      filters: {},
      users: [],

      table: {
        data: [],
        headers: [
          { text: 'Дата', value: 'created_at' },
          { text: 'Пользователь', value: 'user_name' },
          { text: 'Телефон', value: 'phone' },
          { text: 'Код', value: 'code' },
          { text: 'Статус', value: 'status' },
          { text: 'Провайдер', value: 'provider' },
          { text: 'Стоимость', value: 'cost' }
        ],
      },
    }
  },

  mounted () {
    this.loadUsers()
    this.render()
  },

  methods: {
  loadUsers () {
  this.$http.get('/v1/usersflashcall').then((res) => {
    const payload = res?.data || res
    const items = payload?.items || []
    
    this.users = items.map(item => ({
      ...item,
      guid: String(item.id),
      name: item.name || String(item.id)
    }))
  })
},

    onFilterChange (payload) {
    this.filters = payload || {}
    this.render()
  },
render () {
  this.loading = true

  const body = {}

  // даты
  if (this.filters.selectedStartTime && this.filters.selectedEndTime) {
    body.from = this.filters.selectedStartTime
    body.to   = this.filters.selectedEndTime
  } else if (this.filters.date && this.filters.date.length === 2) {
    body.from = `${this.filters.date[0]} 00:00:00`
    body.to   = `${this.filters.date[1]} 23:59:59`
  }

  // телефон
  if (this.filters.search) {
    body.phone = String(this.filters.search).replace(/\D/g, '')
  }

  // пользователь
  const sel = this.filters.select
  if (sel) {
    const uid = Number(sel)
    if (Number.isFinite(uid)) {
      body.user_id = uid
    }
  }

  this.$http.post('/v1/verification-calls', body, (result) => {
    const items = (result && result.items) ? result.items : []

    this.table.data = items.map(item => {
      const d = new Date(item.created_at)
      return {
        ...item,
        created_at: d.toISOString().slice(0, 19).replace('T', ' '),
      }
    })

    this.loading = false
  })
},

    onExport () {
      const rows = this.table.data || []
      if (!rows.length) return

      const header = ['Дата', 'Пользователь', 'Телефон', 'Код', 'Статус', 'Провайдер', 'Стоимость']

      const escape = (val) => {
        const s = String(val == null ? '' : val)
        return `"${s.replace(/"/g, '""')}"`
      }

      const formatCost = (val) => {
        if (val == null) return ''
        const num = Number(val)
        if (!Number.isFinite(num)) return String(val)
        return String(num).replace('.', ',')
      }

      const csvLines = [
        header.map(escape).join(';'),
        ...rows.map(r => [
          escape(r.created_at),
          escape(r.user_name),
          escape(r.phone),
          escape(r.code),
          escape(r.status),
          escape(r.provider),
          escape(formatCost(r.cost)),
        ].join(';'))
      ]

      const blob = new Blob([csvLines.join('\n')], { type: 'text/csv;charset=utf-8;' })
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = 'verification_calls.csv'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      URL.revokeObjectURL(url)
    },
  },
}
</script>

<style scoped>

  /* Меняем заголовок у calls-фильтра (в FilterMy он один .titler внутри filter_item calls) */
.filters .filter_item .titler {
  /* ничего не трогаем глобально */
}

/* Точечно: первый combobox-блок (calls) — меняем текст заголовка через псевдо-элемент */
.filters .filter_item .wrap_titler .titler {
  font-size: 0 !important;
}
.filters .filter_item .wrap_titler .titler::after {
  content: "Выберите пользователя";
  font-size: 14px;
}
.top {
  margin-bottom: 24px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
}

h1 {
  margin-bottom: 24px;
  font-style: normal;
  font-weight: 800;
  font-size: 28px;
  line-height: 130%;
  color: #404247;
}

.render {
  width: 100%;
}

p {
  text-align: left;
}

.history_title {
  font-style: normal;
  font-weight: 800;
  font-size: 28px;
  line-height: 130%;
  color: #404247;
  text-align: left;
  margin-bottom: 8px;
}

.desc {
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 150%;
  color: #55575C;
  text-align: left;
  margin-bottom: 16px;
}

.ok {
  margin-top: 30px;
  background: #E8F7F4;
  width: 100%;
  border-radius: 8px;
  padding: 16px 24px;
}

.vback {
  border: 1px solid #c3c4c6;
  padding: 10px;
  border-radius: 10px;
}

.vback:hover {
  cursor: pointer;
}
</style>
